import {Component, inject, Input, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AdminSearchFilterModel} from '../../../../../api/model/Admin-user.model';

interface AdminSearchForm {
  id: FormControl<string | number>;
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  email: FormControl<string>;
  active: FormControl<boolean>;
}

@Component({
  selector: 'tj-admin-search-form',
  templateUrl: './admin-search-form.component.html',
  styleUrls: ['./admin-search-form.component.scss']
})
export class AdminSearchFormComponent {
  private readonly fb = inject(FormBuilder);

  @Input() filter: AdminSearchFilterModel = {};
  @Input() form: FormGroup<AdminSearchForm>;

  constructor() {
  }

  ngOnInit() {
    const filter = this.filter || {};
    this.form.addControl('id', this.fb.control(filter.id || ''));
    this.form.addControl('firstName', this.fb.control(filter.firstName || ''));
    this.form.addControl('lastName', this.fb.control(filter.lastName || ''));
    this.form.addControl('email', this.fb.control(filter.email || ''));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filter && changes.filter.currentValue === null) {
      this.filter = {};
    }
  }
}
